import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '@chakra-ui/icons';
export const ArrowForwardIcon = ({ fillColor }) => createIcon({
    displayName: 'ArrowForwardIcon',
    viewBox: '0 0 14 14',
    path: (_jsx("path", { d: "M 7 0 L 14 7 L 7 14 L 6 13 L 11 8 L 0 8 L 0 6 L 11 6 L 6 1 L 7 0 Z", fill: fillColor })),
});
//# sourceMappingURL=ArrowForwardIcon.js.map